import { Injectable } from '@angular/core';
import { ThreedProject } from './project-controller';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectControllerService {
  private _project: ThreedProject | undefined;
  private _project$: BehaviorSubject<ThreedProject | undefined> = new BehaviorSubject<
    ThreedProject | undefined
  >(undefined);

  constructor() {}

  get project(): ThreedProject | undefined {
    return this._project;
  }

  set project(project: ThreedProject | undefined) {
    this._project = project;
    this._project$.next(project);
  }

  get project$(): BehaviorSubject<ThreedProject | undefined> {
    return this._project$;
  }

  public initProject(project: ThreedProject): void {
    if (this._project) return;
    this.project = project;
  }
}
